import React, { memo } from 'react'
import styles from './styles.module.scss'
import { useFloralPlanning, FLORAL_PLANNING_OPTIONS } from './useFloralPlanning.hook'
import ProgressBar from '../ProgressBar'

const FloralPlanningPage: React.FC = () => {
  const { selectedOption, handleOptionSelect, handleSubmit, loading } = useFloralPlanning()
  const hasSelection = !!selectedOption

  return (
    <>
      <ProgressBar />
      <div className={styles.floralPlanningPage}>
        <div className={styles.floralPlanningLeftSection}>
          <div className={styles.floralPlanningTextContainer}>
            <span className={styles.floralPlanningTitle}>Where are you in your floral planning journey?</span>
          </div>
        </div>

        <div className={styles.floralPlanningRightSection}>
          <div className={styles.floralPlanningOptionsContainer}>
            {FLORAL_PLANNING_OPTIONS.map((option) => (
              <button
                key={option.id}
                className={`${styles.floralPlanningOptionCard} ${
                  selectedOption === option.id ? styles.floralPlanningSelected : ''
                }`}
                onClick={() => handleOptionSelect(option.id)}
                aria-selected={selectedOption === option.id}
                role="option"
              >
                <span className={styles.floralPlanningOptionTitle}>{option.title}</span>
              </button>
            ))}
          </div>
        </div>
        <div className={styles.floralButtonMobileContainer}>
          <button
            className={
              `${styles.floralButtonMobile} ` + (loading ? styles.saving : hasSelection ? styles.hasValue : '')
            }
            onClick={handleSubmit}
            disabled={!hasSelection || loading}
          >
            {loading ? <span className={styles.savingText}>Saving...</span> : 'Next'}
          </button>
        </div>
      </div>

      <div className={styles.continueDesktopContainer}>
        <div className={styles.continueDesktopWrapper}>
          <button
            className={`${styles.continueButton} ` + (loading ? styles.saving : hasSelection ? styles.hasValue : '')}
            onClick={handleSubmit}
            disabled={!hasSelection || loading}
          >
            {loading ? <span className={styles.savingText}>Saving...</span> : 'Next'}
          </button>
        </div>
      </div>
    </>
  )
}

FloralPlanningPage.displayName = 'FloralPlanningPage'

export default memo(FloralPlanningPage)
